import React from 'react';
import { makeStyles } from '@material-ui/styles';
import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
import IntlMessages from '../../../../@jumbo/utils/IntlMessages';

import ARgmaeAllStoreTable from './ArgameAllData';
import CmcAllStoreTable from './CmsAllData';
import FrontendAllStoreTable from './FrontendAllData';
import CmcDataByStore from './CmsDataByStore';
import ArgameDataByStore from './ArgameDataByStore';

const useStyles = makeStyles(theme => ({
  section: {
    '&:not(:last-child)': {
      marginBottom: theme.typography.pxToRem(32),
    },
  },
  sectionHeading: {
    marginBottom: theme.typography.pxToRem(16),
  },
}));

const breadcrumbs = [
  // { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  // { label: <IntlMessages id={'pages.editTable'} />, isActive: true },
];

export default function Table() {
  const classes = useStyles();
  return (
    <PageContainer heading={<IntlMessages id="pages.chart.cms" />} breadcrumbs={breadcrumbs}>
      <FrontendAllStoreTable />
      <CmcAllStoreTable />
      {/* <ARgmaeAllStoreTable /> */}
      <CmcDataByStore />
      {/* <ArgameDataByStore /> */}
    </PageContainer>
  );
}
